import __request__ from "routing/request";
export function exportWidget(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.widgetexport/widgetexport/export", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(widgetExportRequestId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.widgetexport/widgetexport/${widgetExportRequestId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function widgetValues(JSONbody, widgetExportRequestId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.widgetexport/widgetexport/${widgetExportRequestId}/values`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
